import { useState } from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

import UserService from '../../../http/user-service';
import { DbUser } from '../../../types/user';

interface SetPasswordDialogProps {
    user: DbUser;
    open: boolean;
    onClose: () => void;
}

const SetPasswordDialog = ({ user, open, onClose }: SetPasswordDialogProps) => {
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        if (loading) return;
        setPassword('');
        setConfirm('');
        setError('');
        onClose();
    };

    const handleSubmit = async () => {
        if (password.length < 5) { setError('Пароль должен содержать минимум 5 символов'); return; }
        if (password !== confirm) { setError('Пароли не совпадают'); return; }
        setLoading(true);
        setError('');
        try {
            await UserService.adminSetPassword(user.user_id, password);
            handleClose();
        } catch {
            setError('Не удалось задать пароль');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
            onKeyDown={(e) => { if (e.key === 'Enter' && !loading) handleSubmit(); }}
        >
            <DialogTitle>Задать пароль — {user.login}</DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '16px !important' }}>
                <TextField
                    label="Новый пароль"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoFocus
                    fullWidth
                    size="small"
                />
                <TextField
                    label="Повторите пароль"
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    fullWidth
                    size="small"
                />
                {error && <Alert severity="error">{error}</Alert>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={loading} disableElevation>
                    {loading ? <CircularProgress size={18} /> : 'Задать'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SetPasswordDialog;
